
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './modern-theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

// ✅ Read the callbackUrl that Electron passes after Auth0 redirects
const params = new URLSearchParams(window.location.search);
const callbackUrl = params.get("callbackUrl");
const redirectUri = window.location.protocol === "file:"
  ? "lessongen://callback"
  : window.location.origin;

if (callbackUrl) {
  const parsed = new URL(callbackUrl);
  // Replace current URL so Auth0 SDK sees the code & state
  window.history.replaceState({}, "", parsed.pathname + parsed.search);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
        scope: "openid profile email offline_access",
        redirect_uri: redirectUri
        
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

reportWebVitals();
